import { Flex, List, Modal, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

type RequirementsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const RequirementsModal = ({ isOpen, onClose }: RequirementsModalProps) => {
  const intl = useIntl();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={intl.formatMessage(MESSAGES.requirementsModalTitle)} size="small">
      <Flex direction="column" gap="8">
        <Text textWrap="pretty">{intl.formatMessage(MESSAGES.requirementsModalBody)}</Text>
        <Flex direction="column" gap="2">
          <Text fontWeight="semiBold">{intl.formatMessage(MESSAGES.requirementsModalListHeading)}</Text>
          <List>
            <List.Item>{intl.formatMessage(MESSAGES.requirementsModalRuleGaps)}</List.Item>
            <List.Item>{intl.formatMessage(MESSAGES.requirementsModalRuleNoTransactions)}</List.Item>
          </List>
        </Flex>
        <Text>{intl.formatMessage(MESSAGES.requirementsModalFootnote)}</Text>
      </Flex>
    </Modal>
  );
};
